import React, { useState } from 'react'
import profile from "../../../assets/img/temp/profile.png"
import useFetch from '../../../hooks/useAxios';

const Commentbox = ({info}) => {

  return (
    <div className='commentbox'>
       <div className='flex items-center commentbox-header'>
         <img src={info.author.avatar} className='rounded-[50%]'/>
         <dinfov>
           <h3>{info.author.full_name}</h3>
           <p>   {info.author.role} جاتیک</p>
         </dinfov>

       </div>
        <p className='commnet-text'>{info.body}</p>
    </div>
  )
}
const RegisterCommentBox = () => {
  const [infoHome, setinfoHome] = useState([]); //city //start //end //count
  const apiGetHomeInfo = useFetch({
    method: "get",
    url: "api/home/feedbacks",
    noHeader: true,
    trigger: true,
    argFunc: res => setinfoHome(res.data)
  });
  console.log(infoHome)
  return (
    <div className='RegisterCommentBox'>
       {infoHome.map(i=><Commentbox info={i} />) }
       
        
    </div>
  )
}

export default RegisterCommentBox